var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcMov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#073551;}\n\t.st1{fill:#48A8FF;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#2477B5;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#38A3FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,268.5 80.7,230.3 80.7,268.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "471.3,268.5 390.5,230.3 390.5,268.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.4,2l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V60.1C31.9,28,57.5,2,89,2H276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,168H336.3c-31.5,0-59.9-28.9-59.9-61V2L439.4,168z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 268.5,
    className: "st3",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106,305.1h19l26.5,62l26.5-62h18.9v83.4h-16.7v-54.2l-22.3,54.2h-12.7l-22.4-54.2v54.2H106V305.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.7,389.2c-23.5,0-42.8-17.7-42.8-42.8c0-25,19.2-42.6,42.8-42.6c23.8,0,42.6,17.7,42.6,42.6 C286.3,371.6,267.4,389.2,243.7,389.2z M243.7,374.3c15,0,25.4-10.9,25.4-27.8s-10.4-27.6-25.4-27.6c-15.2,0-25.6,10.6-25.6,27.6 S228.5,374.3,243.7,374.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.5,305.1h17.8l-30.6,83.4h-20.3l-30.6-83.4h17.9l22.9,66.3L347.5,305.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 139,
    cy: 126.5,
    r: 52.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 139,
    cy: 126.5,
    r: 30.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139,126.5c-4.6,4.6-4.6,12.2,0,16.8l35.8,35.8h16.8v-16.8l-35.8-35.8C151.2,121.9,143.6,121.9,139,126.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcMov);
export default __webpack_public_path__ + "static/media/ac_mov.571c74beab079bd9b4251e1a4e3d418e.svg";
export { ForwardRef as ReactComponent };